import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.FETCH_PACKAGE_DETAIL.REQUEST, saga.fetchPackageDetail);
    yield takeLatest(ACTION.FETCH_PACKAGE_DETAIL.FAILED, saga.onFetchPackageDetailFailed);
}
